import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: localStorage.getItem("billingData")
    ? JSON.parse(localStorage.getItem("billingData"))
    : null,
  tariffs: localStorage.getItem("tariffsData")
    ? JSON.parse(localStorage.getItem("tariffsData"))
    : null,
};

const billingSlice = createSlice({
  name: "billing",
  initialState,
  reducers: {
    setBilling(state, action) {
      state.data = action.payload;
    },
    setTariffs(state, action) {
      state.tariffs = action.payload;
    },
  },
});

export const { setTariffs, setBilling } = billingSlice.actions;

export default billingSlice.reducer;
